import { SettingsDataObject } from '@next/core-lib/settings';

export interface Product extends SettingsDataObject {
  id: number;
  code: string;
  name: string;
  country?: string;
  phase?: string;
  isActive: boolean;
  animalType: string;
  type: string;
}

export enum ViewMode {
  View,
  Create,
  Edit,
}

export enum ProductType {
  Feed = 'Feed',
  Additive = 'Additive',
}

export enum ApplicationKeys {
  PoultryNextSustainability = 'PoultryNEXTSustainability',
}
